/* esm.sh - unhead@2.1.12/dist/shared/unhead.yem5I2v_ */
export * from "/*unhead@2.1.12/esnext/dist/shared/unhead.yem5I2v_.mjs";
